import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { PRIVACY_POLICY_ITEMS, POLICY_EFFECTIVE_DATE } from '../data/settingsPolicyContent';
import useAppConfig from '../hooks/useAppConfig';

function Privacy() {
  const { data: config } = useAppConfig();
  const items = config?.privacyPolicy?.items?.length > 0 
    ? config.privacyPolicy.items 
    : PRIVACY_POLICY_ITEMS;
  const effectiveDate = config?.privacyPolicy?.lastUpdated 
    ? new Date(config.privacyPolicy.lastUpdated).toLocaleDateString()
    : POLICY_EFFECTIVE_DATE;

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-grow pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl mt-10">
          <div className="mb-12 text-center">
            <h1 className="text-4xl font-bold tracking-tight text-[#570033] sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="mt-4 text-base text-slate-500">
              Effective Date: {effectiveDate}
            </p>
          </div>
          
          <div className="space-y-8 text-slate-700">
            {items.map((item, index) => (
              <div key={index} className="rounded-2xl border border-slate-100 bg-slate-50 p-6 sm:p-8">
                <h3 className="mb-3 text-xl font-bold text-slate-900">{item.title}</h3>
                <p className="text-base leading-relaxed">{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;
